
import React, { Suspense, lazy, useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AppContext } from "./context/AppContext";

const LoginPage = lazy(() => import("./login/LoginPage"));
const UpdatePassworSystem = lazy(() => import("./login/UpdatePasswordPage"));
const AdminPanel = lazy(() => import("./login/Administrador/AdminPanel"));
const EnterprisePanel = lazy(() => import("./login/Empresa/EnterprisePanel"));
const NewInvoice = lazy(() => import("./login/Empresa/NuevaFactura/NewInvoice"));
const AdminSection = lazy(() => import("./login/Administrador/AdminSection"));
const Section = lazy(() => import("./login/Administrador/Section"));
const AdminProduct = lazy(() => import("./login/Administrador/AdminProduct"));
const Product = lazy(() => import("./login/Administrador/Product"));
const ProductDashboard = lazy(() => import("./login/Administrador/ProductForm/ProductDashboard"));
const Warehouses = lazy(() => import("./login/Administrador/ProductForm/Warehouses"));
const AdminProforma = lazy(() => import("./login/Administrador/AdminProforma"));
const Proforma = lazy(() => import("./login/Administrador/Proforma"));
const AdminClient = lazy(() => import("./login/Administrador/AdminClient"));
const Client = lazy(() => import("./login/Administrador/Client"));
const ClientDetail = lazy(() => import("./login/Administrador/ClientForm/ClientDetail"));
const AdminVariant = lazy(() => import("./login/Administrador/AdminVariant"));
const Variant = lazy(() => import("./login/Administrador/Variant"));
const AdminPromotion = lazy(() => import("./login/Administrador/AdminPromotion"));
const Promotion = lazy(() => import("./login/Administrador/Promotion"));
const AdminServices = lazy(() => import("./login/Administrador/AdminServices"));
const Services = lazy(() => import("./login/Administrador/Services"));
const AdminInvoice = lazy(() => import("./login/Administrador/AdminInvoice"));
const Invoice = lazy(() => import("./login/Administrador/Invoice"));
const RegisterPurchase = lazy(() => import("./login/Administrador/RegisterPurchase"));
const AdminAccounts = lazy(() => import("./login/Administrador/AdminAccounts"));
const DailyBook = lazy(() => import("./login/Administrador/AccountsForm/DailyBook "));
const AccountingConfig = lazy(() => import("./login/Administrador/AccountsForm/AccountingConfig"));
const AdminMotion = lazy(() => import("./login/Administrador/AdminMotion"));
const Motion = lazy(() => import("./login/Administrador/Motion"));
const MotionDetail = lazy(() => import("./login/Administrador/MotionForm/MotionDetail"));
const AdminBank = lazy(() => import("./login/Administrador/AdminBank"));
const Bank = lazy(() => import("./login/Administrador/Bank"));
const Payment = lazy(() => import("./login/Administrador/Payment/Payment"));
const ProformaFacturacion = lazy(() => import("./login/Administrador/ProformaForm/ProformaFacturacion"));
const AdminEcommerce = lazy(() => import("./login/Administrador/AdminEcommerce"));
const Ecommerce = lazy(() => import("./login/Administrador/Ecommerce"));
const AdminStatistics = lazy(() => import("./login/Administrador/AdminStatistics"));

const ProtectedRoute = ({ children }) => {
  const { user, authLoading } = useContext(AppContext);

  if (authLoading) return null;

  if (!user?.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (user.accountType !== "admin") {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AdminRoute = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

const AppRoutes = () => (
  <Suspense fallback={null}>
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/system/update-password" element={<UpdatePassworSystem />} />

      <Route path="/admin-panel" element={<AdminRoute><AdminPanel /></AdminRoute>} />
      <Route path="/admin-panel/*" element={<AdminRoute><AdminPanel /></AdminRoute>} />
      <Route path="/admin-panel/empresa" element={<AdminRoute><EnterprisePanel /></AdminRoute>} />
      <Route path="/admin-panel/secciones" element={<AdminRoute><AdminSection /></AdminRoute>} />
      <Route path="/admin-panel/secciones/nueva" element={<AdminRoute><Section /></AdminRoute>} />
      <Route path="/admin-panel/inventario/productos" element={<AdminRoute><AdminProduct /></AdminRoute>} />
      <Route path="/admin-panel/inventario/productos/nuevo" element={<AdminRoute><Product /></AdminRoute>} />
      <Route path="/admin-panel/inventario/productos/:id" element={<AdminRoute><ProductDashboard /></AdminRoute>} />
      <Route path="/admin-panel/inventario/bodegas" element={<AdminRoute><Warehouses /></AdminRoute>} />
      <Route path="/admin-panel/proformas" element={<AdminRoute><AdminProforma /></AdminRoute>} />
      <Route path="/admin-panel/proformas/nueva" element={<AdminRoute><Proforma /></AdminRoute>} />
      <Route path="/admin-panel/proformas/editar/:id" element={<AdminRoute><Proforma /></AdminRoute>} />
      <Route path="/admin-panel/servicios" element={<AdminRoute><AdminServices /></AdminRoute>} />
      <Route path="/admin-panel/servicios/nuevo" element={<AdminRoute><Services /></AdminRoute>} />
      <Route path="/admin-panel/clientes" element={<AdminRoute><AdminClient /></AdminRoute>} />
      <Route path="/admin-panel/clientes/nuevo" element={<AdminRoute><Client /></AdminRoute>} />
      <Route path="/admin-panel/clientes/:id" element={<AdminRoute><ClientDetail /></AdminRoute>} />
      <Route path="/admin-panel/inventario/variantes" element={<AdminRoute><AdminVariant /></AdminRoute>} />
      <Route path="/admin-panel/inventario/variantes/nueva" element={<AdminRoute><Variant /></AdminRoute>} />
      <Route path="/admin-panel/inventario/movimientos" element={<AdminRoute><AdminMotion /></AdminRoute>} />
      <Route path="/admin-panel/inventario/movimientos/nuevo" element={<AdminRoute><Motion /></AdminRoute>} />
      <Route path="/admin-panel/inventario/movimientos/:id" element={<AdminRoute><MotionDetail /></AdminRoute>} />
      <Route path="/admin-panel/promociones" element={<AdminRoute><AdminPromotion /></AdminRoute>} />
      <Route path="/admin-panel/promociones/nueva" element={<AdminRoute><Promotion /></AdminRoute>} />
      <Route path="/admin-panel/registro/documento" element={<AdminRoute><NewInvoice /></AdminRoute>} />
      <Route path="/admin-panel/reporte/documento" element={<AdminRoute><AdminInvoice /></AdminRoute>} />
      <Route path="/admin-panel/compras/registro" element={<AdminRoute><RegisterPurchase /></AdminRoute>} />
      <Route path="/admin-panel/factura/:id" element={<AdminRoute><Invoice /></AdminRoute>} />
      <Route path="/admin-panel/nota-credito/:id" element={<AdminRoute><Invoice /></AdminRoute>} />
      <Route path="/admin-panel/nota-debito/:id" element={<AdminRoute><Invoice /></AdminRoute>} />
      <Route path="/admin-panel/guia-remision/:id" element={<AdminRoute><Invoice /></AdminRoute>} />
      <Route path="/admin-panel/retencion/:id" element={<AdminRoute><Invoice /></AdminRoute>} />
      <Route path="/admin-panel/compra/:id" element={<AdminRoute><Invoice /></AdminRoute>} />
      <Route path="/admin-panel/admin-cuentas" element={<AdminRoute><AdminAccounts /></AdminRoute>} />
      <Route path="/admin-panel/admin-cuentas/libro-diario" element={<AdminRoute><DailyBook /></AdminRoute>} />
      <Route path="/admin-panel/admin-cuentas/configuracion" element={<AdminRoute><AccountingConfig /></AdminRoute>} />
      <Route path="/admin-panel/bancos" element={<AdminRoute><AdminBank /></AdminRoute>} />
      <Route path="/admin-panel/bancos/nuevo" element={<AdminRoute><Bank /></AdminRoute>} />
      <Route path="/admin-panel/pagos/:id" element={<AdminRoute><Payment /></AdminRoute>} />
      <Route path="/admin-panel/proformas/facturacion/:id" element={<AdminRoute><ProformaFacturacion /></AdminRoute>} />
      <Route path="/admin-panel/ecommerce" element={<AdminRoute><AdminEcommerce /></AdminRoute>} />
      <Route path="/admin-panel/ecommerce/:ticket" element={<AdminRoute><Ecommerce /></AdminRoute>} />
      <Route path="/admin-panel/estadisticas" element={<AdminRoute><AdminStatistics /></AdminRoute>} />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </Suspense>
);

const App = () => (
  <Router>
    <AppRoutes />
  </Router>
);

export default App;
